import React from "react";
import Stack from "@mui/material/Stack";
import { useSharedSelector } from "../../store/SharedProvider";

import { selectIsAdvancedModeEnabled } from "../../store/app-configurations/app-configurations-selectors";
import NavigatorSettingsConfig from "./CleaningConfiguration/NavigatorSettingsConfig";
import WaypointsConfiguration from "./CleaningConfiguration/WaypointsConfiguration";
import GlobalCleaningConfiguration from "./CleaningConfiguration/global/GlobalCleaningConfiguration";

const CleaningConfigurationPage: React.FC<{ webSoftwareVersion?: string | null }> = ({ webSoftwareVersion }) => {
  const isAdvancedModeEnabled = useSharedSelector((state) => selectIsAdvancedModeEnabled(state));

  return (
    <React.Fragment>
      <Stack spacing={2} width="100%" alignItems="center" p={0.3}>
        <GlobalCleaningConfiguration />
        {isAdvancedModeEnabled && <NavigatorSettingsConfig webSoftwareVersion={webSoftwareVersion} />}
        {isAdvancedModeEnabled && <WaypointsConfiguration />}
      </Stack>
    </React.Fragment>
  );
};

export default CleaningConfigurationPage;
